import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1920px;
  background-color: var(--white);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  // Back Button
  .backButton {
    width: 100%;
    max-width: 1133px;
    display: flex;
    justify-content: flex-start;
    margin: 20px 0px 0px 0px;
  }

  .backButton button {
    background-color: var(--white);
    border: 0px;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    color: var(--black);
    cursor: pointer;
    transition: 0.2s all;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    padding: 0px 0px 0px 0px;
  }

  .backButton button span {
    margin: 2px 10px 0px 0px;
    transform: translate(0, 0);
    font-size: 1.4em;
    transition: 0.2s all;
  }

  .backButton button:hover {
    color: var(--orange);
  }

  .backButton button:hover > span {
    transform: translate(-20px, 0);
    color: var(--orange);
  }

  // Formulario
  form {
    width: 100%;
    max-width: 1133px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
  }

  // CheckBox Ike
  .checkBoxIke {
    width: 100%;
    margin: 55px 0px 25px 0px;
    display: flex;
    justify-content: space-between;
    align-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  // CheckBox Container
  .checkBoxContainer {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start;
  }

  // CheckBox Container Input
  .checkBoxContainer input {
    position: relative;
    cursor: pointer;
    border: 0px !important;
    outline: 0px !important;
    margin: 3px 0px 0px 0px;
    border-radius: 6px !important;
    color: var(--white) !important;
    background-color: var(--white) !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  // CheckBox Container Input Before
  .checkBoxContainer input:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background-color: #adadad;
    border-radius: 6px;
    transition: 0.2s;
  }

  // CheckBox Container Input Checked Before
  .checkBoxContainer input:checked:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background-color: #4c8fcc;
  }

  // CheckBox Container Checked After
  .checkBoxContainer input:checked:after {
    content: "";
    display: block;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 2px;
    left: 6px;
  }

  // CheckBox Container Label
  .checkBoxContainer label {
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #044a7f;
    line-height: 24px;
    margin: 0px 0px 0px 35px;
  }

  // CheckBox Container Label Span
  .checkBoxContainer span {
    color: var(--orange);
  }

  // Button Que es Ike Asistencia
  .checkBoxIke a {
    cursor: pointer;
    display: flex;
    align-items: center;
    align-content: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    color: #4c8fcc;
    transition: 0.2s all;
  }

  // Button Que es Ike Asistencia Icon
  .checkBoxIke a span {
    font-size: 15px;
    margin: 3px 10px 0px 0px;
  }

  // Button Que es Ike Asistencia Hover
  .checkBoxIke a:hover {
    color: var(--black);
  }

  // Ike Data Container
  .ikeDataContainer {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    margin: 40px 0px 0px 0px;
  }

  // Text
  .ikeDataContainer p {
    max-width: 515px;
    font-family: Raleway;
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    color: var(--lightgray);
    margin: 0px 0px 0px 15px;
  }

  // Ike Data Container Image Container
  .ikeDataContainer div {
    width: 100%;
    max-width: 75px;
    border-right: 1px solid var(--lightgray);
  }

  // Ike Logo Image
  .ikeDataContainer div img {
    width: calc(100% - 15px);
    margin: 0px 15px 0px 0px;
  }

  .datosPersonales,
  .datosBicicleta,
  .coberturaPago {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 45px 0px 0px 0px;
  }

  .datosPersonales p,
  .datosBicicleta p,
  .coberturaPago p {
    width: 100%;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: var(--black);
    margin: 0px 0px 0px 0px;
  }

  // Inputs Container
  .inputContainer {
    min-width: 300px;
    max-width: 300px;
    margin: 20px 22px 0px 0px;
  }

  // Labels
  .inputContainer label {
    display: block;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    color: var(--black);
    margin: 0px 0px 6px 0px;
  }

  .labelError {
    color: red !important;
  }

  // Input
  .inputContainer input,
  .selectContainer select {
    width: calc(100% - 32px);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    padding: 0px 15px 0px 15px;
    height: 29px;
    border: 1px solid var(--lightgray);
    transition: all 0.25s ease;
    color: var(--lightgray);
    outline: 0;
    margin: 0px 0px 0px 0px;
    border-radius: 3px;
  }

  .inputError {
    border: 1px solid red !important;
  }

  .inputContainer span {
    display: block;
    width: 100% !important;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 0.7em;
    color: red;
    margin: 5px 0px 0px 0px;
  }

  .selectContainer {
    position: relative;
    width: 100%;
  }

  .selectContainer select {
    width: 100%;
    height: 31px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: inline-block;
    cursor: pointer;
    position: relative;
    z-index: 100;
    background-color: transparent;
  }

  // Select Arrow
  .selectContainer i {
    position: absolute;
    right: 15px;
    top: calc(50% - 7px);
    width: 7px;
    height: 7px;
    display: block;
    border-left: 3px solid var(--lightgray);
    border-bottom: 3px solid var(--lightgray);
    transform: rotate(-45deg);
    z-index: 99;
    border-radius: 10%;
  }

  // Select default arrow
  .selectContainer select::-ms-expand {
    display: none;
  }

  // Select Focus
  .selectContainer select:focus {
    border: 1px solid var(--orange) !important;
  }

  // Input Cod. Postal, Cod. Area, Telefono
  #codPostal,
  #codArea,
  #telefono {
    min-width: 140px;
    max-width: 140px;
  }

  #vencimiento input {
    max-width: 108px;
  }

  // Input Focus
  .inputContainer input:focus {
    outline: none;
    border: 1px solid var(--orange);
  }

  // Tarjeta Container
  .tarjetaContainer {
    width: 100%;
    max-width: 644px;
    min-width: 644px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 0px 0px 0px 0px;
  }

  // Tarjeta
  .rccs {
    width: 100% !important;
    margin: 35px 0px 15px 0px !important;
  }

  // Button Container
  .buttonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin: 45px 0px 0px 0px;
  }

  .buttonContainer a {
    background-color: var(--orange);
    padding: 10px 19px 10px 19px;
    border-radius: 6px;
    border: 0px;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    color: var(--white);
    cursor: pointer;
    transition: 0.2s all;
  }

  .buttonContainer a:hover {
    background-color: var(--lightorange);
  }

  #coberturaLaboral {
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    margin: 25px 0px 0px 0px;
    color: var(--black);
  }

  #coberturaLaboral a {
    text-decoration: none;
    color: var(--orange);
  }

  #coberturaLaboral a:hover {
    text-decoration: underline;
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    max-width: 1000px;

    // Inputs Container
    .inputContainer {
      min-width: 255px;
      max-width: 255px;
      margin: 20px 22px 0px 0px;
    }

    // Input Cod. Postal, Cod. Area, Telefono
    #codPostal,
    #codArea,
    #telefono {
      min-width: 120px;
      max-width: 120px;
    }

    // Tarjeta Container
    .tarjetaContainer {
      max-width: 554px;
      min-width: 554px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    max-width: 850px;

    #coberturaLaboral a {
      width: 100%;
      display: block;
      margin: 15px 0px 0px 0px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 700px;
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 600px;

    // Button Que es Ike Asistencia
    .checkBoxIke a {
      margin: 30px 0px 0px 0px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    max-width: 540px;

    // Ike Data Container
    .ikeDataContainer {
      flex-wrap: wrap;
    }

    // Text
    .ikeDataContainer p {
      max-width: 515px;
      margin: 20px 0px 0px 0px;
    }

    // Ike Data Container Image Container
    .ikeDataContainer div {
      border-right: 0px;
    }

    // Inputs Container
    .inputContainer {
      min-width: 240px;
      max-width: 240px;
    }

    // Tarjeta Container
    .tarjetaContainer {
      max-width: 524px;
      min-width: 524px;
    }

    #coberturaLaboral {
      width: 80%;
      line-height: 25px;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    max-width: 480px;

    // Inputs Container
    .inputContainer {
      min-width: 210px;
      max-width: 210px;
    }

    // Tarjeta Container
    .tarjetaContainer {
      max-width: 494px;
      min-width: 494px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    max-width: 400px;

    // Inputs Container
    .inputContainer {
      min-width: 100%;
      max-width: 100%;
    }

    #cuitDni {
      min-width: 58.9%;
      max-width: 58.9%;
    }

    #codPostal {
      min-width: 35%;
      max-width: 35%;
      margin-right: 0px;
    }

    #codArea {
      min-width: 35%;
      max-width: 35%;
    }

    #telefono {
      min-width: 58.9%;
      max-width: 58.9%;
      margin-right: 0px;
    }

    // Tarjeta Container
    .tarjetaContainer {
      max-width: 100%;
      min-width: 100%;
    }

    #coberturaLaboral {
      width: 100%;
      line-height: 25px;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;
  }

  // 408px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    // Inputs Container
    #cuitDni {
      min-width: 57.9%;
      max-width: 57.9%;
    }

    #codPostal {
      min-width: 35%;
      max-width: 35%;
      margin-right: 0px;
    }

    #codArea {
      min-width: 35%;
      max-width: 35%;
    }

    #telefono {
      min-width: 57.9%;
      max-width: 57.9%;
      margin-right: 0px;
    }
  }

  // 352px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile352}) {
    // Inputs Container
    #cuitDni {
      min-width: 56.9%;
      max-width: 56.9%;
    }

    #codPostal {
      min-width: 35%;
      max-width: 35%;
      margin-right: 0px;
    }

    #codArea {
      min-width: 35%;
      max-width: 35%;
    }

    #telefono {
      min-width: 56.9%;
      max-width: 56.9%;
      margin-right: 0px;
    }
  }

  // 330px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile330}) {
    // Tarjeta
    .rccs {
      display: none !important;
    }
  }

  // 310px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile310}) {
    // Inputs Container
    .inputContainer {
      min-width: 100% !important;
      max-width: 100% !important;
    }
  }
`;

export default Container;
